

/// <reference path="InvoiceLine.ts" />

// Generated class SalesInvoiceLine_ManagedObject

class SalesInvoiceLine_ManagedObject extends InvoiceLine
{
}
